<template lang="pug">
    .user-profile-image(:style="profileImageStyle" :class="`user-profile-image-${size}`")
</template>

<script>
export default {
    name: 'user-profile-image',

    props: {
        user: {
            type: Object,
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        }
    },

    computed: {
        profileImage() {
            return this.user.profile_image_sm || '/images/client/lairdnd/default-profile-image.png'
        },
        profileImageStyle() {
            return { 'background-image': `url(${this.baseUri}${this.profileImage})` }
        },
    },
}
</script>
